import templateUrl from '../home-banner-template.html';

export const homeBannerMainComponent = {
	templateUrl,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
		onSubmit: '&',
		disableButtons: '<',
		parentSlug: '@'
	},

	//controller for HomeBannerMainComponent
	controller: class HomeBannerMainComponent {
		constructor($state, ModalService, CompareObjectService) {
			'ngInject';

			this.$state = $state;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
		}

		$onInit() {
			this.details = this.details || {
				title: "",
				description: "",
				buttonText: "",
				url: "",
				image: "",
				ada: {
					banner_image_text: ''
				}
			};
			this.saveData = angular.copy(this.details);
		}

		onCoverPicUpload({details: {uuid}}) {
			this.details.image = uuid;
		}

		//on cancel function
		onCancel() {
			const _details = angular.copy(this.details);
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
			if(isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},
	
					buttons: [
						{
							name: 'No'
						},
						{
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}
					]
				});
			} else {
				this._redirectToParentState(this.parentSlug);
			}			

			function onSubmit() {
				this._redirectToParentState(this.parentSlug);
			}
		}

		_redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}

		_onSubmit() {
			this.onSubmit({
				details: this.details
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/home-banner/home-banner-main/home-banner-main.component.js